import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=05f31644&"
import script from "./Promocode.vue?vue&type=script&lang=js&"
export * from "./Promocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f31644')) {
      api.createRecord('05f31644', component.options)
    } else {
      api.reload('05f31644', component.options)
    }
    module.hot.accept("./Promocode.vue?vue&type=template&id=05f31644&", function () {
      api.rerender('05f31644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promocodes/Promocode.vue"
export default component.exports